import { format } from "date-fns";
import { store as notificationStore } from "react-notifications-component";
const SYDNEY_LOCAL_TIME_OFFSET = 11;
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function parseDateTime(start, end) {
  if (!start || !end) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var endTime = end.split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  var endObj = new Date(
    endTime[0],
    endTime[1] - 1,
    endTime[2],
    endTime[3],
    endTime[4],
    endTime[5]
  );

  if (format(startObj, "MMMM do") === format(endObj, "MMMM do")) {
    return (
      format(startObj, "MMMM do, yyyy H:mma") + " - " + format(endObj, "h:mma")
    );
  }
  return (
    format(startObj, "MMMM do, yyyy H:mma") +
    " - " +
    format(endObj, "MMMM do, yyyy H:mma")
  );
}

export function parseStartEndDateTime(start, end) {
  if (!start || !end) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var endTime = end.split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  var endObj = new Date(
    endTime[0],
    endTime[1] - 1,
    endTime[2],
    endTime[3],
    endTime[4],
    endTime[5]
  );

  if (format(startObj, "MMMM do") === format(endObj, "MMMM do")) {
    startObj.setHours(startObj.getHours());
    endObj.setHours(endObj.getHours());
    return (
      format(startObj, "MMM do, yyy h:mma") + " - " + format(endObj, "h:mma")
    );
  }
  startObj.setHours(startObj.getHours());
  endObj.setHours(endObj.getHours());
  return (
    format(startObj, "MMM do, yyy h:mma") +
    " - " +
    format(endObj, "MMM do, yyy h:mma")
  );
}

/* Parse a function in ISO8601 into human readable format. */
export function parseSingleDateTime(start) {
  if (!start) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  startObj.setHours(startObj.getHours());
  return format(startObj, "MMM do, yyy h:mma");
}

/* Parse a ISO8601 format to human readable. */
export function parseToISOSingleDateTime(start) {
  if (!start) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  startObj.setHours(startObj.getHours() + SYDNEY_LOCAL_TIME_OFFSET);
  return format(startObj, "MMM do, yyy h:mma");
}

/* Parse a function in ISO8601 into human readable format. WITHOUT adding offset */
export function parseSingleDateTimeNoConversion(start) {
  if (!start) {
    return "";
  }
  var startTime = start.toString().split(/[^0-9]/);
  var startObj = new Date(
    startTime[0],
    startTime[1] - 1,
    startTime[2],
    startTime[3],
    startTime[4],
    startTime[5]
  );
  return format(startObj, "MMM do, yyy h:mma");
}

export function extractDate(dateTime) {
  if (dateTime === null) {
    return "";
  }
  var timeArray = dateTime.toString().split(/[^0-9]/);
  var dateObj = new Date(
    timeArray[0],
    timeArray[1] - 1,
    timeArray[2],
    timeArray[3],
    timeArray[4],
    timeArray[5]
  );
  return format(dateObj, "MMM do H:mma");
}

/* No offset. */
export function extractTime(dateTime) {
  if (dateTime === null) {
    return "";
  }
  var timeArray = dateTime.toString().split(/[^0-9]/);
  var dateObj = new Date(
    timeArray[0],
    timeArray[1] - 1,
    timeArray[2],
    timeArray[3],
    timeArray[4],
    timeArray[5]
  );
  return format(dateObj, "MMM do h:mma");
}

/* For sending to the server. Offset added */
export function extractTimeNowLocalTime() {
  let dateNowGMT = new Date();
  dateNowGMT.setHours(dateNowGMT.getHours() + SYDNEY_LOCAL_TIME_OFFSET);
  return dateNowGMT.toISOString();
}

/*
For the calendar. Specifically to pull the time back 11 hours to prevent the auto added time.
Takes an ISOTime that is directly from the server (i.e. it is in Sydney time), then it converts it to a date obj then subtracts the offset.
*/
export function subtractOffsetFromISO(isoTime) {
  if (!isoTime) {
    return "";
  }
  var dateObj = new Date(isoTime);
  dateObj.setHours(dateObj.getHours() - SYDNEY_LOCAL_TIME_OFFSET);
  return dateObj.toISOString();
}

/* Opposite of above */
export function addOffsetToISO(isoTime) {
  if (!isoTime) {
    return "";
  }
  var dateObj = new Date(isoTime);
  dateObj.setHours(dateObj.getHours() + SYDNEY_LOCAL_TIME_OFFSET);
  return dateObj.toISOString();
}

/* Takes in a DateObj and returns the month */
export function parseCurrentMonth(dateObj) {
  return MONTHS[dateObj.getMonth()];
}

/* Converts an ISO time into a Date object. */
export function convertISOToLocalDateObj(isoTime) {
  let dateObj = new Date(isoTime);
  return dateObj.setHours(dateObj.getHours() - 11);
}

export function extractAddress(locationArray) {
  if (locationArray === null) {
    return "";
  }
  let locationObj = locationArray.shift();
  return `${locationObj.name}.  ${locationObj.street}, ${locationObj.city}, ${locationObj.region}`;
}

export function notify(head, body, notifytype) {
  return notificationStore.addNotification({
    title: head,
    message: body,
    type: notifytype,
    insert: "top",
    container: "top-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 4000,
    },
  });
}

export function convertISOToAwardDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + dt;
}
